<template>
    <section class="textSection">
        <div>
            <h1>Confirmation</h1>
            <div v-if="valid">
                <p style="margin-left: 150px;">Votre inscription a bien été validée,
                    vous pouvez désormais vous connecter sur le site de Savoir Être Aidant</p>
            </div>
            <div v-else>
                <p style="margin-left: 150px;">Ce lien est invalide ou a expiré.</p>
            </div>
        </div>
    </section>
</template>

<script>
    import UsersService from '../services/users.js'
    export default {
        name: "PasswordRecovery",
        data: function () {
            return {
                valid: true,
            }
        },
        created: function () {
            this.getToken();
        },

        methods: {
            confirmUser: function (token) {
                UsersService.confirmUser(token).then((res) => {
                }, (res) => {
                    console.warn(res)
                });
            },
            getToken: function () {
                UsersService.getToken(
                    {
                        token: this.$route.params.token
                    }).then((res) => {
                        this.confirmUser(res.body['token'])
                }, (res) => {
                    this.valid = false;
                    console.warn(res)
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// RegisterConfirmation.vue?72532c58